<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
  <div class="dialog-title">{{'modules.clients.associations.uploadApartmentsDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content scrollable">
  <div class="dialog-subtitle-label df-c gap5">
    <div class="df gap5">
      <span>{{'modules.clients.associations.uploadApartmentsDialog.labels.association' | translate}}</span>
      <span class="bold">{{data.association.name}}</span>
    </div>

    <div class="df gap5" *ngIf="data.building && data.building.name">
      <span>{{'modules.clients.associations.uploadApartmentsDialog.labels.building' | translate}}</span>
      <span class="bold">{{data.building.name}}</span>
    </div>
  </div>

  <mat-divider class="divider"></mat-divider>

  <form [formGroup]="uploadForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off">
    <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
      <mat-label>{{'modules.clients.associations.uploadApartmentsDialog.labels.sheetId' | translate}}</mat-label>
      <input type="text" matInput formControlName="sheetId" autocomplete="chrome-off">
      <div class="field-action-button" *ngIf="uploadForm.get('sheetId')?.value">
        <button class="item-action-button gray" (click)="openLink()">
          <mat-icon>visibility</mat-icon>
        </button>
      </div>
    </mat-form-field>

    <div class="df gap20">
      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 250px; min-width: 250px; max-width: 250px;">
        <mat-label>{{'modules.clients.associations.uploadApartmentsDialog.labels.dataType' | translate}}</mat-label>
        <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="dataType">
          <mat-option [value]="'APARTMENTS'">{{'modules.clients.associations.uploadApartmentsDialog.labels.dataTypes.APARTMENTS' | translate}}</mat-option>
          <mat-option [value]="'USERS_APARTMENTS'">{{'modules.clients.associations.uploadApartmentsDialog.labels.dataTypes.USERS_APARTMENTS' | translate}}</mat-option>
          <mat-option [value]="'USERS'">{{'modules.clients.associations.uploadApartmentsDialog.labels.dataTypes.USERS' | translate}}</mat-option>
          <mat-option [value]="'BALANCES'">{{'modules.clients.associations.uploadApartmentsDialog.labels.dataTypes.BALANCES' | translate}}</mat-option>
          <mat-option [value]="'COUNTERS'">{{'modules.clients.associations.uploadApartmentsDialog.labels.dataTypes.COUNTERS' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 170px; min-width: 170px; max-width: 170px;" *ngIf="uploadForm.get('dataType')?.value === 'COUNTERS'">
        <mat-label>{{'Ресурс'}}</mat-label>
        <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="resourceType">
          <mat-option [value]="'COLD_WATER'">{{'ХВ'}}</mat-option>
          <mat-option [value]="'HOT_WATER'">{{'ГВ'}}</mat-option>
          <mat-option [value]="'ELECTRICITY'">{{'Електрика'}}</mat-option>
          <mat-option [value]="'HEATING'">{{'Опалення'}}</mat-option>
          <mat-option [value]="'GAS'">{{'Газ'}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
      <mat-label>{{'modules.clients.associations.uploadApartmentsDialog.labels.sortingType' | translate}}</mat-label>
      <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="sortingType">
        <mat-option [value]="false">{{'modules.clients.associations.uploadApartmentsDialog.labels.sortingTypes.false' | translate}}</mat-option>
        <mat-option [value]="true">{{'modules.clients.associations.uploadApartmentsDialog.labels.sortingTypes.true' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <mat-divider class="divider"></mat-divider>

  <div class="upload-buttons df gap20 jc-sb ai-c">
    <button class="action-button blue" (click)="getRequestData('check')" [disabled]="uploadForm.invalid">
      <mat-icon>upload</mat-icon>
      <span>{{'modules.clients.associations.uploadApartmentsDialog.labels.buttons.fill' | translate}}</span>
    </button>

    <button class="action-button green" (click)="getRequestData('upload', true)" [disabled]="uploadForm.invalid">
      <mat-icon>get_app</mat-icon>
      <span>{{'modules.clients.associations.uploadApartmentsDialog.labels.buttons.upload' | translate}}</span>
    </button>
  </div>
</div>
